module.exports = __webpack_public_path__ + "static/media/Artboard1.a100b03e.png";